import { StoreApiService } from './StoreApiService';

// ---- singletons ----
export const storeApi = new StoreApiService();

// ---- businessId helpers ----
const LS_KEYS = ['businessId', 'currentBusinessId', 'activeBusinessId'];

/**
 * Store only the business ID string in all businessId keys.
 */
export function setCurrentBusinessId(id: string | null) {
  if (!id || typeof id !== "string") return;
  try {
    LS_KEYS.forEach(k => localStorage.setItem(k, id));
  } catch { /* ignore */ }
}

/**
 * Defensive getter: always returns the businessId as a string, never an object.
 */
export function getCurrentBusinessId(): string | null {
  try {
    // Check direct string keys in localStorage
    for (const k of LS_KEYS) {
      const v = localStorage.getItem(k);
      if (v) {
        // If stored as JSON accidentally, extract the string businessId
        if (v.startsWith("{")) {
          try {
            const obj = JSON.parse(v);
            if (typeof obj.businessId === "string") return obj.businessId;
            if (typeof obj._id === "string") return obj._id;
            if (typeof obj.id === "string") return obj.id;
          } catch {}
        } else if (!v.startsWith("[object")) { // If not accidentally an object
          return v;
        }
      }
    }
    // Check for businessId in profile objects
    const profileRaw =
      localStorage.getItem('businessProfile') ||
      localStorage.getItem('userProfile') ||
      localStorage.getItem('authUser');
    if (profileRaw) {
      try {
        const p = JSON.parse(profileRaw);
        const inferred =
          (typeof p.businessId === "string" && p.businessId) ||
          (typeof p.currentBusinessId === "string" && p.currentBusinessId) ||
          (typeof p.activeBusinessId === "string" && p.activeBusinessId) ||
          (typeof p.business?.id === "string" && p.business.id) ||
          (typeof p.business?._id === "string" && p.business._id);
        if (inferred) {
          setCurrentBusinessId(inferred);
          return inferred;
        }
      } catch {}
    }
  } catch { /* ignore */ }
  return 'BIZ-1753642484595'; // fallback for dev/demo
}

// Optionally re-export types for convenience
export type { Store } from './types';